import {Auth} from '@aws-amplify/auth';
import {stage} from "../stage.ts";

type ConfigShape = {
    [key: string]: {
        endpoint: string,
        region: string,
        apiKey?: string,
    }
}

const tenantManagementServiceV2API = {
    prd: {
        endpoint: 'https://nyiyum9zu0.execute-api.us-west-2.amazonaws.com/v2',
        region: 'us-west-2',
        apiKey: 'pac-idam-login-T2BhDhaPwcaGOtmTWupbKccP6F5Fzp254w9g59Ib',
    },
    test: {
        endpoint: 'https://hh3iqenpr2.execute-api.us-west-2.amazonaws.com/v2',
        region: 'us-west-2',
        apiKey: 'pac-idam-login-XqtS4F8m4P3yFNjMkKj3hkNARHgp2lZs0as9xvD1',
    },
    dev: {
        endpoint: 'https://hd6kxkz0sa.execute-api.us-west-2.amazonaws.com/v2',
        region: 'us-west-2',
        apiKey: 'pac-idam-login-LoqV8W3o2O1pBFuNuFs5maOWLFrv3qFn7ma3bpQ4',
    },
    ide: {
        endpoint: 'https://hd6kxkz0sa.execute-api.us-west-2.amazonaws.com/v2',
        region: 'us-west-2',
        apiKey: 'pac-idam-login-LoqV8W3o2O1pBFuNuFs5maOWLFrv3qFn7ma3bpQ4',
    },
} as ConfigShape;

export const getApiKey = () => tenantManagementServiceV2API[stage].apiKey;

const getCustomHeader = async () => {
    try {
        const token = (await Auth.currentSession())
            .getIdToken()
            .getJwtToken();
        return {
            Authorization: `${token}`,
            'x-api-key': tenantManagementServiceV2API[stage].apiKey,
        };
    } catch (e) {
        return {
            'x-api-key': tenantManagementServiceV2API[stage].apiKey,
        };
    }
};

let API = {
    endpoints: [
        {
            name: 'TenantManagementServiceV2API',
            endpoint: tenantManagementServiceV2API[stage].endpoint,
            region: tenantManagementServiceV2API[stage].region,
            custom_header: getCustomHeader,
        },
    ],
};

export default API;
